<template>
  <div v-if="data" class="text-static-default-hi">
    <Breadcrumb :category="data.category" />

    <TheMainContent>
      <RevContainer class="bg-surface-default-low pb-56 md:pb-72">
        <h1 class="heading-1 mt-32 text-center">
          {{ data.category.pageTitle }}
        </h1>
        <SuggestedCategories class="mt-56" />
      </RevContainer>
    </TheMainContent>

    <AdditionalContent
      :content="data.content"
      :custom-content-first="false"
      :relatedComparePages
    />
  </div>
</template>

<script lang="ts" setup>
import { useAsyncData } from '#imports'
import { computed } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { RevContainer } from '@ds/components/Container'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'

import Breadcrumb from '../../components/Breadcrumb/Breadcrumb.vue'
import AdditionalContent from '../../components/Search/AdditionalContent/AdditionalContent.vue'
import SuggestedCategories from '../../components/SuggestedCategories/SuggestedCategories.vue'
import { useCurrentCategory } from '../../composables/useCurrentCategory'
import { useFetchInternalLinkCards } from '../../composables/useFetchInternalLinkCards/useFetchInternalLinkCards'
import { useModelsComparisonHead } from '../../composables/useModelsComparisonHead/useModelsComparisonHead'

const currentCategory = useCurrentCategory()
const $httpFetch = useHttpFetch()
const logger = useLogger()
const fetchInternalLinkCards = useFetchInternalLinkCards()

const { data, error } = await useAsyncData(
  `model-comparison-search-${currentCategory}`,
  async () => {
    const [pageData, { hubRelatedComparePages }] = await Promise.all([
      $httpFetch('/bm/models-comparison/categories/:category', {
        pathParams: { category: String(currentCategory) },
      }),
      fetchInternalLinkCards(),
    ])

    return { ...pageData, relatedComparePages: hubRelatedComparePages }
  },
)

if (error.value) {
  logger.error('[ModelComparisonSearch] Failed to fetch', {
    error: error.value,
    owners: ['bot-squad-content-front'],
  })
}

const relatedComparePages = computed(
  () => data.value?.relatedComparePages ?? [],
)

useModelsComparisonHead(() => data.value?.content)
</script>
